export const FETCH_SPACES_STATUS = "FETCH_SPACES_STATUS";
export const FETCH_SPACES_STATUS_SUCCESS = "FETCH_SPACES_STATUS_SUCCESS";
export const FETCH_SPACES_STATUS_FAILS = "FETCH_SPACES_STATUS_FAILS";

export const FETCH_ALL_SPACES = "FETCH_ALL_SPACES";
export const FETCH_ALL_SPACES_SUCCESS = "FETCH_ALL_SPACES_SUCCESS";
export const FETCH_ALL_SPACES_FAILS = "FETCH_ALL_SPACES_FAILS";

export const FETCH_FILTERED_SPACE_DETAILS = "FETCH_FILTERED_SPACE_DETAILS";
export const FETCH_FILTERED_SPACE_DETAILS_SUCCESS = "FETCH_FILTERED_SPACE_DETAILS_SUCCESS";
export const FETCH_MORE_SPACE_DETAILS_SUCCESS = "FETCH_MORE_SPACE_DETAILS_SUCCESS";
export const FETCH_FILTERED_SPACE_DETAILS_FAILS = "FETCH_FILTERED_SPACE_DETAILS_FAILS";

export const FETCH_SPACES_DETAILS = "FETCH_SPACES_DETAILS";
export const FETCH_SPACES_DETAILS_SUCCESS = "FETCH_SPACES_DETAILS_SUCCESS";
export const FETCH_SPACES_DETAILS_FAILS = "FETCH_SPACES_DETAILS_FAILS";

export const FETCH_CALENDER_VISITS_DATA = 'FETCH__CALENDER_VISITS_FILTER_DATA';
export const FETCH_CALENDER_VISITS_DATA_SUCCESS = 'FETCH_CALENDER_VISITS_DATA_SUCCESS';
export const FETCH_CALENDER_VISITS_DATA_FAILS = 'FETCH_CALENDER_VISITS_DATA_FAILS';

export const FETCH_CALENDER_BOOKING_DATA = 'FETCH__CALENDER_BOOKING_FILTER_DATA';
export const FETCH_CALENDER_BOOKING_DATA_SUCCESS = 'FETCH_CALENDER_BOOKING_DATA_SUCCESS';
export const FETCH_CALENDER_BOOKING_DATA_FAILS = 'FETCH_CALENDER_BOOKING_DATA_FAILS';

export const FETCH_BOOKING_SELECTED_DATE = 'FETCH_BOOKING_SELECTED_DATE';
export const FETCH_BOOKING_SELECTED_DATE_SUCCESS = 'FETCH_BOOKING_SELECTED_DATE_SUCCESS';
export const FETCH_BOOKING_SELECTED_DATE_FAILS = 'FETCH_BOOKING_SELECTED_DATE_FAILS';

export const CREATE_RESERVATION = 'CREATE_RESERVATION';
export const CREATE_RESERVATION_SUCCESS = 'CREATE_RESERVATION_SUCCESS';
export const CREATE_RESERVATION_FAILED = 'CREATE_RESERVATION_FAILED';

export const UPDATE_RESERVATION = 'UPDATE_RESERVATION';
export const UPDATE_RESERVATION_SUCCESS = 'UPDATE_RESERVATION_SUCCESS';
export const UPDATE_RESERVATION_FAILED = 'UPDATE_RESERVATION_FAILED';

export const FETCH_SPACE_AVAILABILITY = "FETCH_SPACE_AVAILABILITY";
export const FETCH_SPACE_AVAILABILITY_SUCCESS = "FETCH_SPACE_AVAILABILITY_SUCCESS";
export const FETCH_SPACE_AVAILABILITY_FAILS = "FETCH_SPACE_AVAILABILITY_FAILS";
export const CLEAR_SPACE_AVAILABILITY = "CLEAR_SPACE_AVAILABILITY";
export const CLEAR_CALENDAR_DATA = "CLEAR_CALENDAR_DATA";

export const CANCEL_SELECTED_BOOKING = 'CANCEL_SELECTED_BOOKING';
export const CANCEL_SELECTED_BOOKING_SUCCESS = 'CANCEL_SELECTED_BOOKING_SUCCESS';
export const CANCEL_SELECTED_BOOKING_FAIL = 'CANCEL_SELECTED_BOOKING_FAIL';

export const FETCH_SELECTED_SPACE = 'FETCH_SELECTED_SPACE';
export const FETCH_SELECTED_SPACE_SUCCESS = 'FETCH_SELECTED_SPACE_SUCCESS';
export const FETCH_SELECTED_SPACE_FAIL = 'FETCH_SELECTED_SPACE_FAIL';

export const UPDATE_VISIT_STATUS = 'UPDATE_VISIT_STATUS';
export const UPDATE_VISIT_STATUS_SUCCESS = 'UPDATE_VISIT_STATUS_SUCCESS';
export const UPDATE_VISIT_STATUS_FAIL = 'UPDATE_VISIT_STATUS_FAIL';

export const SPACE_STATUS = {
    ACTIVE : 'ACTIVE',
    PENDING : 'PENDING',
    INACTIVE : 'INACTIVE',
    DECLINED : 'DECLINED'
}

export const GET_USER_AUTHORIZATION = "GET_USER_AUTHORIZATION";
export const GET_USER_AUTHORIZATION_SUCCESS = "GET_USER_AUTHORIZATION_SUCCESS";
export const GET_USER_AUTHORIZATION_FAIL = "GET_USER_AUTHORIZATION_FAIL";

export const GET_CALENDAR_LIST = "GET_CALENDAR_LIST";
export const GET_CALENDAR_LIST_SUCCESS = "GET_CALENDAR_LIST_SUCCESS";
export const GET_CALENDAR_LIST_FAIL = "GET_CALENDAR_LIST_FAIL";

export const CALENDER_ADD_TO_SPACE = "CALENDER_ADD_TO_SPACE";
export const CALENDER_ADD_TO_SPACE_SUCCESS = "CALENDER_ADD_TO_SPACE_SUCCESS";
export const CALENDER_ADD_TO_SPACE_FAIL = "CALENDER_ADD_TO_SPACE_FAIL";

export const GET_LOGGED_USER_STATUS = "GET_LOGGED_USER_STATUS";
export const GET_LOGGED_USER_STATUS_SUCCESS = "GET_LOGGED_USER_STATUS_SUCCESS";
export const GET_LOGGED_USER_STATUS_FAIL = "GET_LOGGED_USER_STATUS_FAIL";

export const UN_SYNC_CALENDER_FROM_HOST = "UN_SYNC_CALENDER_FROM_HOST";
export const UN_SYNC_CALENDER_FROM_HOST_SUCCESS = "UN_SYNC_CALENDER_FROM_HOST_SUCCESS";
export const UN_SYNC_CALENDER_FROM_HOST_FAIL = "UN_SYNC_CALENDER_FROM_HOST_FAIL";

export const REMOVE_CALENDER_FROM_SPACE = "REMOVE_CALENDER_FROM_SPACE";
export const REMOVE_CALENDER_FROM_SPACE_SUCCESS = "REMOVE_CALENDER_FROM_SPACE_SUCCESS";
export const REMOVE_CALENDER_FROM_SPACE_FAIL = "REMOVE_CALENDER_FROM_SPACE_FAIL";

export const SET_SELECTED_CALENDAR = 'SET_SELECTED_CALENDAR';
export const CLEAR_SELECTED_CALENDAR = 'CLEAR_SELECTED_CALENDAR';

export const FETCH_MANAGED_HOSTS = 'FETCH_MANAGED_HOSTS';
export const FETCH_MANAGED_HOSTS_SUCCESS = 'FETCH_MANAGED_HOSTS_SUCCESS';
export const FETCH_MANAGED_HOSTS_FAILS = 'FETCH_MANAGED_HOSTS_FAILS';

